'use client'

import { motion } from 'framer-motion'
import { CircleX, HomeIcon } from 'lucide-react'
import Input from '@/components/elements/Input'
import { Button } from '@/components/elements/Button'
import { formatImageURL } from '@/utils/util'
import { useVerifyResetFlow } from '@/lib/commerce/hooks'

export default function VerifyReset({ vendor }: { vendor: any }) {
  const f = useVerifyResetFlow(vendor)

  if (f.loading) return <div className="w-full max-w-md" />

  return (
    <div className="w-full max-w-md">
      {f.valid ? (
        <div>
          <div className="flex flex-col items-center gap-6">
            {vendor?.logo ? (
              <img src={formatImageURL(vendor?.logo)} alt="logo" className="h-8 max-w-40 w-auto object-contain" />
            ) : vendor?.name ? (
              <div className="text-xl sm:text-2xl font-bold tracking-tight">{vendor?.name}</div>
            ) : null}
            <h1 className="text-center text-foreground text-3xl font-semibold leading-7.5 tracking-[-0.7%]">Нууц үг сэргээх</h1>
          </div>
          <div className="mt-14">
            <form onSubmit={f.handleResetPassword} className="flex flex-col gap-y-4">
              <Input label="Шинэ нууц үг" type="password" value={f.password} onChange={(e: any) => f.setPassword(e.target.value)} placeholder="Таны шинэ нууц үг" onKeyDown={f.handleKeyDown} description="8-аас дээш тэмдэгтэй байх ёстой" />
              <Input label="Шинэ нууц үг давтах" type="password" value={f.passwordRep} onChange={(e: any) => f.setPasswordRep(e.target.value)} placeholder="Шинэ нууц үг давтах" onKeyDown={f.handleKeyDown} />
              <Button type="submit" isLoading={f.btnLoading} variant="outline" className="mt-2 w-full h-10 bg-foreground text-white font-medium! border-foreground hover:bg-foreground/90 hover:text-white transition-all" loadingMessage="Шинэчилж байна...">
                Нууц үг солих
              </Button>
            </form>
          </div>
        </div>
      ) : (
        <div className="flex flex-col gap-4 items-center justify-center">
          <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.3 }}>
            <CircleX className="w-20 h-20 text-destructive" />
          </motion.div>
          <motion.div className="text-center text-xl font-semibold text-foreground leading-9" initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.5 }}>
            Код хүчингүй болсон байна 😢
          </motion.div>
          <motion.div className="grow-0 mt-4" initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 1 }}>
            <Button onClick={f.goToLogin} icon={HomeIcon} variant="outline" className="h-10 bg-foreground text-white font-medium! border-foreground hover:bg-foreground/90 hover:text-white transition-all">
              Нэвтрэх
            </Button>
          </motion.div>
        </div>
      )}
    </div>
  )
}
